import { useInView } from "../hooks/useInView";

export function CTA() {
  const [ref, inView] = useInView();

  return (
    <section id="download" className="relative py-24 bg-bg-primary">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`relative rounded-3xl p-[1px] bg-gradient-to-br from-brand-teal via-brand-indigo to-brand-purple ${
            inView ? "animate-fade-up" : "start-hidden"
          }`}
        >
          <div className="bg-bg-secondary rounded-3xl px-8 py-16 sm:px-16 text-center relative overflow-hidden">
            {/* Waving bot */}
            <img
              src="/images/bots/waving.svg"
              alt=""
              className="absolute -bottom-4 -right-4 w-32 h-32 opacity-20 sm:opacity-40"
            />

            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4 relative z-10">
              Ready to grow your <span className="text-brand-teal">dough</span>?
            </h2>
            <p className="text-text-secondary text-lg mb-8 max-w-md mx-auto relative z-10">
              Download Dough today and start building the financial future you deserve.
            </p>

            <div className="flex flex-wrap items-center gap-4 justify-center relative z-10">
              <a href="https://apps.apple.com/us/app/dough-financial-wellness/id6757439224" className="transition-transform hover:scale-105">
                <img src="/images/appstore-badge.svg" alt="Download on the App Store" className="h-[52px]" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.betteryou.BetterFinance&hl=en_US" className="transition-transform hover:scale-105">
                <img src="/images/googleplay-badge.svg" alt="Get it on Google Play" className="h-[52px]" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
